import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

export const FloatingProductBox: React.FC = () => {
  const { scrollY } = useScroll();

  // Hero section is 748px tall. Center is 374px.
  // We position absolute at top: 374px to match Hero exactly.
  
  // Animation moves the box down to Features section.
  // Features section is after Hero.
  // We want it to end at the end of features.
  // Scroll range extended to 1200px.
  
  // Y movement (relative to initial 374px)
  // Moves down by ~900px to land in Features section
  const y = useTransform(scrollY, [0, 1200], [0, 900]);
  
  // Rotation
  // Starts tilted right (12deg)
  // Ends tilted left (-45deg) as requested
  const rotate = useTransform(scrollY, [0, 1200], [12, -45]);
  
  const scale = useTransform(scrollY, [0, 600, 1200], [1, 0.9, 1]);

  return (
    <div className="absolute top-0 left-0 w-full h-full pointer-events-none z-40 flex justify-center items-start">
      <motion.img
        src="/Images/Packaging Box.webp"
        alt="Floating Product Box"
        className="object-contain relative z-10"
        style={{
          y,
          rotate,
          scale,
          top: '374px', // Center of Hero (748px / 2)
          marginTop: '-200px', // Offset by half of approx image height to center it
          maxWidth: '550px',
          width: '80%', // Responsive width for mobile
          height: 'auto',
          position: 'absolute', // Relative to the wrapper which is absolute in App
        }}
      />
      {/* Scroll-linked Particles */}
      {[...Array(4)].map((_, i) => (
        <Particle key={i} baseY={y} />
      ))}
    </div>
  );
};

const Particle: React.FC<{ baseY: any }> = ({ baseY }) => {
  const randomX = React.useMemo(() => Math.random() * 400 - 200, []);
  const randomSpeed = React.useMemo(() => 0.8 + Math.random() * 0.4, []);
  const randomOffset = React.useMemo(() => Math.random() * 200 - 100, []);

  const y = useTransform(baseY, (value: number) => value * randomSpeed + randomOffset);
  const opacity = useTransform(baseY, [0, 800], [0, 1]);

  return (
    <motion.div
       className="absolute w-2 h-2 rounded-full bg-primary/30 pointer-events-none"
       style={{
         top: '374px',
         left: '50%',
         x: randomX,
         y,
         opacity
       }}
    />
  );
};
